var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.091h30v21.818H0V4.091Z",
    style: {
      fill: "#ba0c2f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30M10.909,4.091v21.818"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "13.636 25.909 8.182 25.909 8.182 17.727 0 17.727 0 12.273 8.182 12.273 8.182 4.091 13.636 4.091 13.636 12.273 30 12.273 30 17.727 13.636 17.727 13.636 25.909",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30M10.909,4.091v21.818"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "12.273 25.909 9.545 25.909 9.545 16.364 0 16.364 0 13.636 9.545 13.636 9.545 4.091 12.273 4.091 12.273 13.636 30 13.636 30 16.364 12.273 16.364 12.273 25.909",
    style: {
      fill: "#00205b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSj);
export default __webpack_public_path__ + "static/media/SJ.cf55463049a60b71623c8f6a91ad08dd.svg";
export { ForwardRef as ReactComponent };